<template>
  <div>
    <p>הזיני מילות מפתח לאיתור בקורות החיים (חשוב לרדת שורה בין ביטוי/מילה)</p>
    <textarea v-model="innerValue" />
    <div class="modal_footer">
      <a @click="onSubmit" class="button is-info">Submit</a>
    </div>
  </div>
</template>

<script>
// libraries
import { mapActions } from 'vuex'

export default {
  name: 'KeyWordsUpsert',
  props: {
    payload: Object
  },
  data () {
    return {
      innerValue: this.payload.data.value || ''
    }
  },
  methods: {
    ...mapActions('settings', ['fetchSettings']),
    async onSubmit () {
      try {
        const r = await this.$network_utils.updateSetting({
          id: this.payload.data.id,
          value: this.innerValue
        })
        await this.$network_utils.postEvent({
          event: 'refresh_key_words',
          current_type: 'Applicant',
          current_resource_id: 1
        })
        this.fetchSettings()
        this.$utils.emit('show_toast', {
          text: `Success: You successfully updated the following tag: ${r.var}`
        })
      } catch (e) {
        this.$utils.emit('show_toast', { text: `Error: try again` })
        console.error(e)
      }
    }
  }
}
</script>

<style scoped></style>
